module.exports = __webpack_public_path__ + "static/media/Notes.8c5d0868.png";